<template>
  <span v-html="$icons.get('caret_down', 'small')"></span>
</template>

<script>
export default { 
  name: 'OpenIndicator'
}
</script>
